import { useRequest } from 'features/request/useRequest';
import { useResetStoreData } from 'features/request/useResetStoreData';
import type { BimChapterEnum, BimWorkOrderPriceStatesData } from 'gql/graphql';

import { useCallback, useEffect, useMemo } from 'react';
import { useDispatch } from 'react-redux';

import { bimWorkOrderVersionPriceStatesGql } from '../workOrderVersionQueries';

const requestId = 'bimWorkOrderVersionPriceStates';

export const useBimWorkOrderVersionPriceStates = (chapter?: BimChapterEnum, workOrderVersionObjectId?: number) => {
    const dispatch = useDispatch();
    const [bimWorkOrderVersionPriceStatesReset] = useResetStoreData({ requestId });

    const variables = useMemo(
        () => (chapter && workOrderVersionObjectId ? { chapter, workOrderVersionObjectId } : undefined),
        [chapter, workOrderVersionObjectId],
    );

    const [bimWorkOrderPriceVersionStatesData, , , bimWorkOrderPriceStatesRequest] = useRequest({
        requestId,
        query: bimWorkOrderVersionPriceStatesGql,
        variables,
        withEffect: !!chapter && !!workOrderVersionObjectId,
    });

    const bimWorkOrderPriceStatesMakeRequest = useCallback(() => {
        dispatch(bimWorkOrderPriceStatesRequest(variables));
    }, [bimWorkOrderPriceStatesRequest, dispatch, variables]);

    const data = useMemo(
        () =>
            bimWorkOrderPriceVersionStatesData?.bimWorkOrderVersionPriceStates?.data ||
            ({} as BimWorkOrderPriceStatesData),
        [bimWorkOrderPriceVersionStatesData?.bimWorkOrderVersionPriceStates?.data],
    );

    useEffect(() => {
        bimWorkOrderVersionPriceStatesReset(undefined);
    }, [bimWorkOrderVersionPriceStatesReset]);

    return {
        bimWorkOrderPriceVersionStatesData: data,
        bimWorkOrderPriceStatesMakeRequest,
    };
};
